module.exports = __webpack_public_path__ + "media/american-bittern-1.31a6f0f2.mp3";